import React, { memo, useEffect } from 'react'

import Hls from 'hls.js'

interface Props {
  streamUrl?: string
  autoplay?: boolean
  videoRef: React.RefObject<HTMLVideoElement>
  controls?: boolean
}

const CCTVPlayer = ({
  streamUrl,
  autoplay = false,
  videoRef,
  controls = false,
}: Props) => {
  useEffect(() => {
    const video = videoRef.current
    let hls

    const isHLS = streamUrl?.includes('.m3u8')

    const tryPlay = () => {
      const playPromise = video?.play()
      if (playPromise !== undefined) {
        playPromise.catch((err) => {
          // eslint-disable-next-line no-console
          console.warn('Autoplay prevented:', err)
        })
      }
    }

    if (isHLS && Hls.isSupported()) {
      hls = new Hls({
        lowLatencyMode: true,
        maxLiveSyncPlaybackRate: 1.5,
        backBufferLength: 60,
        maxBufferLength: 20,
      })

      hls.attachMedia(video)
      hls.loadSource(streamUrl)

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        tryPlay()
      })

      hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              hls.startLoad()
              break
            case Hls.ErrorTypes.MEDIA_ERROR:
              hls.recoverMediaError()
              break
            default:
              hls.destroy()
              break
          }
        }
      })
    } else if (video.canPlayType('application/vnd.apple.mpegurl') && isHLS) {
      video.src = streamUrl
      // video.addEventListener('loadedmetadata', tryPlay)
    } else {
      video.src = streamUrl
      // video.addEventListener('loadedmetadata', tryPlay)
    }

    return () => {
      if (hls) hls.destroy()
    }
  }, [streamUrl])

  return (
    <video
      ref={videoRef}
      controls={controls}
      autoPlay={autoplay}
      muted
      playsInline
      loop
      style={{
        width: '100%',
        height: 'calc(100vh - 10rem)',
        background: 'black',
      }}
    />
  )
}

export default memo(CCTVPlayer)
